import { Injectable, inject } from '@angular/core';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';

/**
 * Remembers the last visited route.  Typically set on logout, or route guards
 * and used on login or after guard is satisfied to take user to where they were
 * originally trying to go.
 */
@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private $localStorage = inject(LocalStorageService);
  private $sessionStorage = inject(SessionStorageService);


  clearLastVisitedRoute(): void {
    this.$localStorage.clear('lastVisitedRoute');
    this.$sessionStorage.clear('lastVisitedRoute');
  }

  getLastVisitedRoute() {
    return this.$localStorage.retrieve('lastVisitedRoute') || this.$sessionStorage.retrieve('lastVisitedRoute');
  }

  setLastVisitedRoute(route: string): void {
    // This is the route with the auth code on it, and should be considered a redirect, not a page to return to.
    if (route.indexOf('/auth/google') > -1) {
      return;
    }

    this.$localStorage.store('lastVisitedRoute', route);
    this.$sessionStorage.store('lastVisitedRoute', route);
  }

}
